/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { EmbersTableBase } from './tableBase/tableBase';
import { EmbersTableBottomControls } from './bottomControls/tableBottomControls';
import { EmbersTableTopControls } from './topControls/topControls';
import { StyledTableWrapper } from './tableStyles';
import { useId } from '../utils/useId';
export function EmbersTable(props) {
  var loading = props.loading,
    loadingText = props.loadingText,
    tableBaseClassName = props.tableBaseClassName,
    bottomControlsClassName = props.bottomControlsClassName,
    className = props.className,
    isDataSorted = props.isDataSorted,
    order = props.order,
    orderBy = props.orderBy,
    setOrderBy = props.setOrderBy,
    headCells = props.headCells,
    columnSelectionStorageKey = props.columnSelectionStorageKey,
    expandColumnId = props.expandColumnId,
    rows = props.rows,
    selected = props.selected,
    setSelected = props.setSelected,
    bodyCheckboxesLabels = props.bodyCheckboxesLabels,
    identifier = props.identifier,
    eyeColumn = props.eyeColumn,
    dataMapping = props.dataMapping,
    mappedKeys = props.mappedKeys,
    onRefresh = props.onRefresh,
    lastUpdated = props.lastUpdated,
    onPaginationChange = props.onPaginationChange,
    pageCount = props.pageCount,
    currentPage = props.currentPage,
    onResultsPerPageChange = props.onResultsPerPageChange,
    resultsPerPage = props.resultsPerPage,
    resultsPerPageOptions = props.resultsPerPageOptions,
    total = props.total,
    loadMoreStep = props.loadMoreStep,
    showLoadMore = props.showLoadMore,
    topControlsClassName = props.topControlsClassName,
    customizedActions = props.customizedActions,
    actions = props.actions,
    maxActionNumberInView = props.maxActionNumberInView,
    message = props.message,
    defaultMode = props.defaultMode,
    onModeChange = props.onModeChange,
    searchOptions = props.searchOptions,
    filterOptions = props.filterOptions,
    filterRows = props.filterRows,
    locale = props.locale,
    filterValue = props.filterValue,
    onFilterChange = props.onFilterChange,
    maxHeight = props.maxHeight,
    stickyHeader = props.stickyHeader,
    onRowClick = props.onRowClick,
    headerCheckboxDisabled = props.headerCheckboxDisabled,
    getRowCheckboxDisabled = props.getRowCheckboxDisabled,
    getRowDisabled = props.getRowDisabled,
    rowDisabledClassName = props.rowDisabledClassName,
    getExtraRowClasses = props.getExtraRowClasses,
    _props$withTopControl = props.withTopControls,
    withTopControls = _props$withTopControl === void 0 ? true : _props$withTopControl,
    tableCollectionString = props.tableCollectionString,
    scrollContainerClass = props.scrollContainerClass,
    mixpanelProps = props.mixpanelProps,
    caption = props.caption,
    _id = props.id;
  var id = useId(_id);
  var topControlsProps = {
    total: total,
    selectedCount: selected ? selected.length : void 0,
    className: topControlsClassName,
    customizedActions: customizedActions,
    actions: actions,
    maxActionNumberInView: maxActionNumberInView,
    onRefresh: onRefresh,
    loading: loading,
    loadingText: loadingText,
    defaultMode: defaultMode,
    onModeChange: onModeChange,
    searchOptions: searchOptions,
    filterOptions: filterOptions,
    filterRows: filterRows,
    locale: locale,
    filterValue: filterValue,
    onFilterChange: onFilterChange,
    tableCollectionString: tableCollectionString,
    mixpanelProps: mixpanelProps
  };
  var tableBaseProps = {
    isDataSorted: isDataSorted,
    order: order,
    orderBy: orderBy,
    setOrderBy: setOrderBy,
    headCells: headCells,
    columnSelectionStorageKey: columnSelectionStorageKey,
    expandColumnId: expandColumnId,
    rows: rows,
    selected: selected,
    setSelected: setSelected,
    bodyCheckboxesLabels: bodyCheckboxesLabels,
    identifier: identifier,
    eyeColumn: eyeColumn,
    dataMapping: dataMapping,
    mappedKeys: mappedKeys,
    className: tableBaseClassName,
    message: message,
    maxHeight: maxHeight,
    stickyHeader: stickyHeader,
    loading: loading,
    onRowClick: onRowClick,
    headerCheckboxDisabled: headerCheckboxDisabled,
    getRowCheckboxDisabled: getRowCheckboxDisabled,
    rowDisabledClassName: rowDisabledClassName,
    getExtraRowClasses: getExtraRowClasses,
    tableCollectionString: tableCollectionString,
    scrollContainerClass: scrollContainerClass,
    mixpanelProps: mixpanelProps,
    caption: caption,
    id: id,
    getRowDisabled: getRowDisabled
  };
  var bottomControlsProps = {
    lastUpdated: lastUpdated,
    onPaginationChange: onPaginationChange,
    pageCount: pageCount,
    currentPage: currentPage,
    onResultsPerPageChange: onResultsPerPageChange,
    resultsPerPage: resultsPerPage,
    resultsPerPageOptions: resultsPerPageOptions,
    loadMoreStep: loadMoreStep,
    showLoadMore: showLoadMore,
    className: bottomControlsClassName,
    mixpanelProps: mixpanelProps,
    message: message
  };
  return /*#__PURE__*/React.createElement(StyledTableWrapper, {
    className: "EmbersIntegratedTable-root".concat(className ? " ".concat(className) : ''),
    id: id
  }, withTopControls && /*#__PURE__*/React.createElement(EmbersTableTopControls, topControlsProps), /*#__PURE__*/React.createElement(EmbersTableBase, tableBaseProps), !loading && /*#__PURE__*/React.createElement(EmbersTableBottomControls, bottomControlsProps));
}